import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icons-build",
  "use": "icons-build-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icons-build\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.15,12.34a6,6,0,0,1-5.89,1.4L6,22,3,21,2,18l8.26-8.26a6,6,0,0,1,7.48-7.48L13.68,6.32,14.5,9.5l3.18.82,4.06-4.06A6,6,0,0,1,20.15,12.34Z\" /><polygon fill=\"currentColor\" fill-rule=\"evenodd\" points=\"18.5 3.5 20 4 20.5 5.5 17 9 15.5 8.5 15 7 18.5 3.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol